export const initialState = {
  name: '',
  phone: '',
}